import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetGuestRideApprovalQueryVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
}>;


export type GetGuestRideApprovalQuery = { __typename?: 'query_root', guestrides_by_pk?: { __typename?: 'guestrides', id: number, status: string, guest_name: string, pickup_address?: string | null, dropoff_address?: string | null, reference_num?: string | null, config: object, created_at: string, created_by?: string | null, approval_user_id?: number | null, approval_requested_at?: string | null, approval_decision?: string | null, approval_decided_at?: string | null, approval_decision_reason?: string | null, approval_estimate?: object | null, approver?: { __typename?: 'users', id: number, display_name: string } | null } | null };


export const GetGuestRideApprovalDocument = gql`
    query GetGuestRideApproval($id: bigint!) {
  guestrides_by_pk(id: $id) {
    id
    status
    guest_name
    pickup_address
    dropoff_address
    reference_num
    config
    created_at
    created_by
    approval_user_id
    approval_requested_at
    approval_decision
    approval_decided_at
    approval_decision_reason
    approval_estimate
    approver {
      id
      display_name
    }
  }
}
    `;

/**
 * __useGetGuestRideApprovalQuery__
 *
 * To run a query within a React component, call `useGetGuestRideApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuestRideApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuestRideApprovalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGuestRideApprovalQuery(baseOptions: Apollo.QueryHookOptions<GetGuestRideApprovalQuery, GetGuestRideApprovalQueryVariables> & ({ variables: GetGuestRideApprovalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuestRideApprovalQuery, GetGuestRideApprovalQueryVariables>(GetGuestRideApprovalDocument, options);
      }
export function useGetGuestRideApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuestRideApprovalQuery, GetGuestRideApprovalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuestRideApprovalQuery, GetGuestRideApprovalQueryVariables>(GetGuestRideApprovalDocument, options);
        }
// @ts-ignore
export function useGetGuestRideApprovalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGuestRideApprovalQuery, GetGuestRideApprovalQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuestRideApprovalQuery, GetGuestRideApprovalQueryVariables>;
export function useGetGuestRideApprovalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuestRideApprovalQuery, GetGuestRideApprovalQueryVariables>): Apollo.UseSuspenseQueryResult<GetGuestRideApprovalQuery | undefined, GetGuestRideApprovalQueryVariables>;
export function useGetGuestRideApprovalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGuestRideApprovalQuery, GetGuestRideApprovalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGuestRideApprovalQuery, GetGuestRideApprovalQueryVariables>(GetGuestRideApprovalDocument, options);
        }
export type GetGuestRideApprovalQueryHookResult = ReturnType<typeof useGetGuestRideApprovalQuery>;
export type GetGuestRideApprovalLazyQueryHookResult = ReturnType<typeof useGetGuestRideApprovalLazyQuery>;
export type GetGuestRideApprovalSuspenseQueryHookResult = ReturnType<typeof useGetGuestRideApprovalSuspenseQuery>;
export type GetGuestRideApprovalQueryResult = Apollo.QueryResult<GetGuestRideApprovalQuery, GetGuestRideApprovalQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/guestRides/approval/getGuestRideApproval.query.gql}
 */
export async function getGuestRideApproval(
  variables: GetGuestRideApprovalQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetGuestRideApprovalQuery['guestrides_by_pk']>
export async function getGuestRideApproval(
  variables: GetGuestRideApprovalQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetGuestRideApprovalQuery>
export async function getGuestRideApproval(
  variables: GetGuestRideApprovalQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetGuestRideApprovalQuery['guestrides_by_pk'] | GetGuestRideApprovalQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetGuestRideApprovalQuery>(
    GetGuestRideApprovalDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.guestrides_by_pk
}